export default "__VITE_ASSET__qXyeMXjC__"